module.exports = __webpack_public_path__ + "static/media/super-mais.da0cb578.svg";